import {
  authAuthorized,
  authDashboardAccess,
  authReady,
  authRole,
  authUser
} from '../composables/auth/authState.js'

/**
 * Authentication guard for the router.
 * Lives in its own module (without view imports) so it can be unit tested.
 */
export function authGuard(to) {
  // Update document title
  document.title = to.meta.title
    ? `${to.meta.title} - Frisse Blikken Sourcing`
    : 'Frisse Blikken Sourcing'

  // Skip auth check in dev mode
  const skipAuth = import.meta.env.VITE_SKIP_AUTH === 'true'
  if (skipAuth) {
    if (to.path === '/login') return '/'
    return true
  }

  const requiresAuth = to.meta.requiresAuth !== false
  const isAuthenticated = !!authUser.value
  const isAuthorized = authAuthorized.value

  if (!requiresAuth) {
    if (to.path === '/login' && isAuthenticated && isAuthorized) return '/'
    return true
  }

  // main.js waits for initAuth() before mounting the router. The guard still
  // fails closed if it is ever called before that initialization completes.
  if (!authReady.value) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  if (requiresAuth && !isAuthenticated) {
    return { path: '/login', query: { redirect: to.fullPath } }
  }

  if (requiresAuth && isAuthenticated && !isAuthorized) {
    return { path: '/login', query: { error: 'not_authorized' } }
  }

  if (to.meta.requiresDashboard && !authDashboardAccess.value) {
    return '/aanvragen'
  }

  if (to.meta.requiresAdmin && authRole.value !== 'admin') {
    return '/'
  }

  return true
}
